module.exports = __webpack_public_path__ + "img/arm.9d320a2e.svg";